import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionFundBillDeliverySearch = () => {
  const transactionFundBillDeliverySearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/fund-bill/delivery-search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { transactionFundBillDeliverySearch }
}

export default InteractorTransactionFundBillDeliverySearch
